import React from "react";
import PropTypes from "prop-types";

import styles from "./DropdownTag.css";

const DropdownTag = (props) => <div className={styles.root}>{props.content}</div>;

DropdownTag.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

export default DropdownTag;
